export const pensionMixin = {
  computed: {
    startDate() {
      return this.getItem.requirements.startDate;
    },
    pensioner() {
      return this.getItem.requirements.member.name;
    },
    isRatify() {
      return this.getItem.requirements.ratify;
    },
    isTris() {
      return this.getItem.requirements.eligibility.reasons === 'The pension will be a transition to retirement pension';
    },
    isPartOne() {
      return this.getItem.setup.part === 'PART_1';
    },
    isPartTwoMini() {
      return this.getItem.setup.part === 'PART_2_MINI';
    },
    isPartTwo() {
      return this.getItem.setup.part === 'PART_2_FULL';
    },
    isFixedAmount() {
      return this.getItem.setup.howMuch === 'A fixed amount';
    },
    isWholeAccumAct() {
      return this.getItem.setup.howMuch === 'The whole balance of the pensioner\'s accumulation account';
    },
    isAccumLessFixed() {
      return this.getItem.setup.howMuch === 'The balance of the pensioner\'s accumulation account less a fixed amount';
    },
    accumulation() {
      return this.getItem.accumulation;
    },
    accumAmount() {
      return this.getItem.accumulation.amount;
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    pension() {
      return this.pensions.length > 0
        ? this.pensions[this.activePension]
        : null;
    },
    pensionAmount() {
      return this.pension ? this.pension.amount : null;
    },
    pensionFixedAmount() {
      return this.pension ? this.pension.fixedAmount : null;
    },
    calculatedPensionAmount() {
      if (this.isAccumLessFixed) {
        return this.accumAmount - this.pension.fixedAmount;
      }
      return this.isFixedAmount
        ? this.pension.fixedAmount
        : this.pension.amount;
    },
  },
};

export default pensionMixin;
